import Typography from '@mui/material/Typography';
import renderDangerousText from '@/utils/renderDangerousText';

interface Props {
    content: string;
}

const ShowNoteContent = ({ content }: Props) => (
    <Typography
        sx={{
            px: 1,
        }}
    >
        {renderDangerousText(content)}
    </Typography>
);
export default ShowNoteContent;
